import React, {Fragment, useMemo} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle,
    TableActionIconEdit, TableActionIconView, TableActionIconDelete
} from "./BaseTableComponents";

import './Table.scss'

const FamilyTable = (props) =>
{
    const onClickItem = (family_id, mode) =>
    {
        props.clickHandler( mode, family_id );
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const url = '/home/child/' + props.child_id + '/families/adoptee/' + row.id;

        return (
            <Fragment>
                <TableActionIconDelete text="Delete Family" onClick={() => onClickItem(row.id, 'delete')} />
                <TableActionIconEdit text="Edit Family Details" onClick={() => onClickItem(row.id, 'edit')} />
                <TableActionIconView text="View Family Members" to={url} />
            </Fragment>
        );
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        family_name: {borderRadius: defaultTopLeftCellStyle},
        type_name: {width: "15vw"},
        view: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "100px"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "family_name",
                text: "Name",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "type_name",
                text: "Family/Group",
                headerStyle: headerStyle
            },
            {
                dataField: "view",
                text: "Manage",
                formatter: linkFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default FamilyTable;

FamilyTable.propTypes = {
    child_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};
